// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"93":"list","767":"details","818":"auth","845":"profile","922":"edit"}[chunkId] || chunkId) + "." + {"93":"0515c37c","326":"f1f87c44","334":"ab5502c2","767":"5347977d","818":"d4075ac5","845":"d6980f78","922":"748354d1"}[chunkId] + ".css";
};